'use client';

import { Box, VStack } from '@terra/ui-styled-system';
import { Text, Spinner } from '@terra/ui-design-system';
import type { TerraIcon } from '@terra/ui-icons';
import type { ReactNode } from 'react';

type EmptyStateProps = {
  icon: TerraIcon;
  title: string;
  description?: string;
  isLoading?: boolean;
  action?: ReactNode;
  iconSize?: number;
  iconColor?: string;
};

export function EmptyState({
  icon: Icon,
  title,
  description,
  isLoading = false,
  action,
  iconSize = 24,
  iconColor = 'var(--colors-fg-muted)',
}: EmptyStateProps) {
  if (isLoading) {
    return (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        h="full"
        w="full"
        p="6"
      >
        <VStack gap="4" alignItems="center">
          <Spinner size="md" />
          <Text fontSize="sm" color="fg.muted">
            {title}
          </Text>
        </VStack>
      </Box>
    );
  }

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      h="full"
      w="full"
      p="6"
    >
      <VStack gap="4" alignItems="center" maxW="md">
        <Icon size={iconSize} color={iconColor} />
        <VStack gap="2" alignItems="center">
          <Text fontSize="sm" fontWeight="medium" color="fg.default">
            {title}
          </Text>
          {description && (
            <Text fontSize="xs" color="fg.muted" textAlign="center">
              {description}
            </Text>
          )}
        </VStack>
        {action}
      </VStack>
    </Box>
  );
}
